import styled from "styled-components";

export const ArenaHeaderButtonLabelDefaultBox = styled.div`
  flex-grow: 1;
  color: ${({theme}) => theme.colors.textLight};
  ${({theme}) => theme.font.presets.medium};
  font-size: 9px;
  letter-spacing: 0.76px;
  text-align: center;
  text-overflow: ellipsis;
  padding-bottom: 5px;
  overflow: hidden;
  width: 100%;

  @media ${({theme}) => theme.mediaQuery.lAndBelow + " and " + theme.mediaQuery.mAndAbove} {
    font-size: 16px;
  }
`;
